export default __webpack_public_path__ + "static/alkosto-38ff84721343495e8345e05583c66fb2.jpg";